import React, { useEffect, useState } from 'react'
import ContentHeader from 'components/UI/ContentHeader/ContentHeader'
import useTableFixedHeader from 'hooks/useTableFixedHeader'
import { superAxiosRequest } from 'axiosApi'
import Loader from 'components/ContentBox/Global/Loader/Loader'
import THead from 'components/ContentBox/Global/ReportTable/THead'
import styles from './GroupLaunchSpeed.module.scss'
import ExportExcelButton from '../ExportExcelButton/ExportExcelButton'
import { NavLink, useHistory } from 'react-router-dom'
import { ExcelRowsParams } from 'components/utils/ExcelExport'
import { observer } from 'mobx-react'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalization from 'hooks/useLocalization'
import SearchBooks from 'components/Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import { timeConverter } from 'components/ContentBox/Online-schedule/components/functions'

const GroupLaunchSpeed = () => {
  const {
    refWrapper,
    refSticky,
    refThead,
    data,
    setData,
    isLoading,
    setIsLoading,
  } = useTableFixedHeader()
  const dateAfter = new Date()
  dateAfter.setMonth(dateAfter.getMonth() - 1)
  const firstDayOfLastMonth = new Date(new Date(dateAfter).setDate(1))
  const lastDayOfLastMonth = new Date(new Date().setDate(0))
  const [catalog, setCatalog] = useState({})
  const [filter, updateFilter] = useLocalStorageFilter()
  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const history = useHistory()
  const { translate } = useLocalization({
    section: 'ebooks',
    subsection: 'ebooks_books',
    dict: {
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
      filter: 'Filter',
      company: 'Company',
      reset_all: 'Reset all',
      apply: 'Apply',
      search: 'Search',
      start_date: 'Start date',
      end_date: 'End date',
    },
  })

  const filterCnf = [
    {
      type: 'select-multi',
      label: 'Локация',
      placeholder: 'Локация',
      values: catalog?.locations,
      sort_key: 'name',
      nameState: 'location',
    },
    {
      type: 'date_day_picker',
      defaultDate: {
        after: firstDayOfLastMonth,
        before: lastDayOfLastMonth,
      },
      nameState: ['date_from', 'date_until'],
      label: 'Период',
      isRequired: true,
    },
    {
      type: 'switcher',
      label: 'Все даты',
      name: 'all_dates',
      nameState: 'all_dates',
    },
  ]

  const cols = [
    { name: 'ФИО ученика' },
    { name: 'Письменный тест' },
    { name: 'Интервал' },
    { name: 'Устный тест' },
    { name: 'Интервал' },
    { name: 'Первое занятие' },
    { name: 'Количество дней' },
  ]

  const calculateAverageInterval = (interval1, interval2) => {
    const validIntervals = [interval1, interval2].filter(
      (val) => val !== null && val !== undefined,
    )
    return validIntervals.length > 0
      ? Math.round(
          validIntervals.reduce((sum, val) => sum + val, 0) /
            validIntervals.length,
        )
      : '-' // Если данных нет, возвращается '-'
  }

  useEffect(() => {
    if (filter && Object.keys(filter).length > 0) {
      setIsLoading(true)

      const { all_dates, date_from, date_until } = filter
      const params = { ...filter, all_dates: all_dates ?? false }

      if (all_dates === true) {
        if (date_from && date_until) {
          // Если all_dates=true и обе даты присутствуют
          params.date_from = timeConverter(date_from, 'today')
          params.date_until = timeConverter(date_until, 'today')
        } else {
          // Если даты отсутствуют при all_dates=true, удаляем их
          delete params.date_from
          delete params.date_until
        }
      } else if (all_dates === false || all_dates === undefined) {
        // Если all_dates=false, заполняем default даты
        params.date_from = timeConverter(
          date_from ? date_from : firstDayOfLastMonth,
          'today',
        )
        params.date_until = timeConverter(
          date_until ? date_until : lastDayOfLastMonth,
          'today',
        )
      }

      superAxiosRequest({
        method: 'get',
        link: 'progress_report/group_launch_speed',
        params,
      })
        .then(({ data }) => {
          setCatalog(data)
          setData(data.report)
          setIsLoading(false)
        })
        .catch(() => {
          setIsLoading(false)
        })
    }
  }, [filter])

  useEffect(() => {
    setIsLoading(true)
    superAxiosRequest({
      method: 'get',
      link: 'progress_report/group_launch_speed',
    })
      .then(({ data }) => {
        setIsLoading(false)
        setCatalog(data)
      })
      .catch(() => setIsLoading(false))
  }, [])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== '/reports/groups_launch_speed') {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  const downloadExcel = () => {
    import('xlsx-js-style').then((XLSX) => {
      const headRows = [
        [
          {
            v: 'ФИО ученика',
            ...ExcelRowsParams.headerRowParam,
          },
          {
            v: 'Письменный тест',
            ...ExcelRowsParams.headerRowParam,
          },
          {
            v: 'Интервал',
            ...ExcelRowsParams.headerRowParam,
          },
          {
            v: 'Устный тест',
            ...ExcelRowsParams.headerRowParam,
          },
          {
            v: 'Интервал',
            ...ExcelRowsParams.headerRowParam,
          },
          {
            v: 'Первое занятие',
            ...ExcelRowsParams.headerRowParam,
          },
          {
            v: 'Количество дней',
            ...ExcelRowsParams.headerRowParam,
          },
        ],
      ]

      let wscols = [
        { wch: 40 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
        { wch: 30 },
      ]

      let rows = [{ hpx: 40 }, { hpx: 40 }]

      let tableData = []

      data.forEach((client) => {
        tableData.push([
          {
            v: `${client.name}`,
            ...ExcelRowsParams.tableRowParam.firstCell,
          },
          {
            v: `${client.written_test_date}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${client.written_verbal_interval}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${client.verbal_test_date}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${client.verbal_first_lesson_interval}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${client.first_lesson_date}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
          {
            v: `${getDaysAwaitingGroup(client.first_lesson_date, client.written_test_date)}`,
            ...ExcelRowsParams.tableRowParam.cell,
          },
        ])
      })

      tableData.unshift([
        {
          v: `Итого (среднее количество дней)`,
          ...ExcelRowsParams.footerRowParams.firstCell,
        },
        {
          v: ``,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: ``,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: ``,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: ``,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: ``,
          ...ExcelRowsParams.footerRowParams.cell,
        },
        {
          v: `${Math.round(data.reduce((acc, row) => acc + getDaysAwaitingGroup(row.first_lesson_date, row.written_test_date), 0) / data.length)}`,
          ...ExcelRowsParams.footerRowParams.cell,
        },
      ])

      let wb = XLSX.utils.book_new()
      const ws = XLSX.utils.aoa_to_sheet([...headRows, ...tableData])
      ws['!rows'] = rows
      ws['!cols'] = wscols

      XLSX.utils.book_append_sheet(wb, ws, 'List 1')
      XLSX.writeFile(wb, 'Скорость запуска групп с 1 теста до 1 занятия.xlsx')
    })
  }

  const getDaysAwaitingGroup = (first_lesson_date, test_start_date) =>
    Math.floor(
      (new Date(first_lesson_date) -
        (test_start_date ? new Date(test_start_date) : new Date())) /
        (24 * 60 * 60 * 1000),
    )

  return (
    <div>
      <ContentHeader title='Скорость запуска групп с 1 теста до 1 занятия'>
        <div className={styles.filter}>
          <SearchBooks
            onSearch={(text) => {
              updateFilter({ ...filter, search: text })
              changeTextValue('search', {
                key: 'search',
                label: 'Search',
                value: text,
              })
            }}
            onClear={() => {
              const { search, ...obj } = filter
              updateFilter(obj)
              setTextValues(
                filterTextValues.filter((field) => field.key !== 'search'),
              )
            }}
            translate={translate}
            placeholder={`Search...`}
            value={filter?.search || ''}
          />
          {!!filterTextValues.length && (
            <FilterTextValues
              onDelete={(key) => {
                const { [key]: _, ...obj } = filter
                updateFilter(obj)
              }}
            />
          )}
          {isOpenFilter && (
            <AsideFilter
              translate={translate}
              getFilterParams={updateFilter}
              config={filterCnf}
              filterValue={filter}
              onDropFilter={() => {
                updateFilter({})
                closeFilter()
              }}
            />
          )}
        </div>
      </ContentHeader>
      {isLoading ? (
        <Loader />
      ) : data && data.length > 0 ? (
        <>
          <div className={styles.excel}>
            <ExportExcelButton downloadExcel={downloadExcel} data={data} />
          </div>
          <div className={styles.tableWrapper} ref={refWrapper}>
            <div ref={refSticky} className={styles.sticky}>
              <table className={styles.table}>
                <THead mode='new' cols={cols} />
              </table>
            </div>
            <table className={`${styles.table} ${styles.tbodyStriped}`}>
              <THead mode='new' cols={cols} ref={refThead} />
              <tbody className={styles.tbody}>
                <tr>
                  {/* ФИО ученика */}
                  <td
                    className={`${styles.tdTotal} ${styles.colName}`}
                    colSpan={1}
                  >
                    Итого (среднее количество дней)
                  </td>

                  {/* Письменный тест */}
                  <td
                    className={`${styles.tdTotal} ${styles.colWrittenTest}`}
                  ></td>

                  {/* Интервал 1 */}
                  <td className={`${styles.tdTotal} ${styles.colInterval}`}>
                    {Math.round(
                      data.reduce(
                        (acc, row) => acc + (row.written_verbal_interval || 0),
                        0,
                      ) /
                        data.filter(
                          (row) => row.written_verbal_interval !== undefined,
                        ).length,
                    )}
                  </td>

                  {/* Устный тест */}
                  <td
                    className={`${styles.tdTotal} ${styles.colVerbalTest}`}
                  ></td>

                  {/* Интервал 2 */}
                  <td className={`${styles.tdTotal} ${styles.colInterval}`}>
                    {Math.round(
                      data.reduce(
                        (acc, row) =>
                          acc + (row.verbal_first_lesson_interval || 0),
                        0,
                      ) /
                        data.filter(
                          (row) =>
                            row.verbal_first_lesson_interval !== undefined,
                        ).length,
                    )}
                  </td>

                  {/* Первое занятие */}
                  <td
                    className={`${styles.tdTotal} ${styles.colFirstLesson}`}
                  ></td>

                  {/* Количество дней */}
                  <td
                    className={`${styles.tdTotal} ${styles.tdTotalDays} ${styles.textAlignLeft} ${styles.colDays}`}
                  >
                    {Math.round(
                      data.reduce(
                        (acc, row) =>
                          acc +
                          getDaysAwaitingGroup(
                            row.first_lesson_date,
                            row.written_test_date,
                          ),
                        0,
                      ) / data.length,
                    )}
                  </td>
                </tr>

                {Array.isArray(data) && (
                  <>
                    {data.map((row, index) => (
                      <tr key={index}>
                        <td
                          className={`${styles.textAlignLeft} ${styles.colName}`}
                        >
                          <NavLink
                            to={'/account_clients/' + row.user_id}
                            target='_blank'
                          >
                            {row.name}
                          </NavLink>
                        </td>
                        <td
                          className={`${styles.textAlignLeft} ${styles.colWrittenTest}`}
                        >
                          {row.written_test_date ? row.written_test_date : '-'}
                        </td>
                        <td
                          className={`${styles.textAlignLeft} ${styles.colWrittenVerbalInterval}`}
                        >
                          {row.written_verbal_interval
                            ? row.written_verbal_interval
                            : '-'}
                        </td>
                        <td
                          className={`${styles.textAlignLeft} ${styles.colVerbalTest}`}
                        >
                          {row.verbal_test_date ? row.verbal_test_date : '-'}
                        </td>
                        <td
                          className={`${styles.textAlignLeft} ${styles.colVerbalFirstLessonInterval}`}
                        >
                          {row.verbal_first_lesson_interval
                            ? row.verbal_first_lesson_interval
                            : '-'}
                        </td>
                        <td
                          className={`${styles.textAlignLeft} ${styles.colFirstLesson}`}
                        >
                          {row.first_lesson_date}
                        </td>
                        <td
                          className={`${styles.textAlignLeft} ${styles.colDays}`}
                        >
                          {getDaysAwaitingGroup(
                            row.first_lesson_date,
                            row.written_test_date,
                          )}
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <h1 className={styles.noData}>Нет данных для отображения!</h1>
      )}
    </div>
  )
}

export default observer(GroupLaunchSpeed)
